import { useTranslation } from 'react-i18next'

import { LinkIcon, ListBulletsIcon, TextTIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const VariableLabel = ({ type, label, variable, example, withoutMarginLeft }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const iconByType = {
    text: TextTIcon,
    link: LinkIcon,
    list: ListBulletsIcon,
  }

  const Icon = iconByType[type]

  return (
    <Styles.Container withoutMarginLeft={withoutMarginLeft}>
      <Styles.Header>
        {Icon && <Icon size={16} />}
        <Text type="bodyMRegular" color={theme.colors.text.default}>
          {t(label)}
        </Text>
        <Text
          type="bodyMItalic"
          customStyles={{ fontStyle: 'italic', fontSize: '14px' }}
          color={theme.colors.text.subtle}
        >
          {variable}
        </Text>
      </Styles.Header>
      {example && (
        <Text type="bodySRegular" color={theme.colors.text.subtle}>
          {t(example)}
        </Text>
      )}
    </Styles.Container>
  )
}

export default VariableLabel
